module.exports = __webpack_public_path__ + "static/assets/bbc0dd79717bfa338a199bb26cdd780b.ttf";